export default __webpack_public_path__ + "static/media/4.797bae0a.png";